/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {setJWT as controlSetJWT} from "@dvrd/dvr-controls";

export let JWTCookieName = 'JWT';

export function setJWT(token: string | null, expires: number = 5) {
    return controlSetJWT(token, {attributes: {expires}, useStorage: false, cookieName: JWTCookieName});
}

export function deleteStorageJWT() {
    try {
        window.localStorage.removeItem(JWTCookieName);
    } catch {
        // Localstorage not supported
    }
}